/**
 * Questionnaire v2 — Étapes 17-18
 * Compte client, résumé, PDF et panier
 */
(function () {
  'use strict';

  let initialized = false;
  let demoisellesChoice = null;
  let demoisellesQuantity = 0;
  let tablesQuantity = 0;
  let tableHonneurChoice = null;
  let tableHonneurPrice = 0;
  let archeChoice = null;
  let archePrice = 0;
  let archeFlowers = 50;
  let chairChoice = null;
  let chairQuantity = 0;
  let chairPrice = 0;
  let selectedBouquets = [];

  function workshopParticipantsInput() {
    return document.getElementById('workshop-participants-input');
  }

  function getElement(id) {
    return document.getElementById(id);
  }

  function safeAddEventListener(element, event, handler, options) {
    if (!element) return;
    if (element === document || element === window) {
      element.addEventListener(event, handler, options || false);
      return;
    }
    if (element.dataset && element.dataset.qv2SummaryBound) return;
    element.dataset.qv2SummaryBound = '1';
    element.addEventListener(event, handler, options || false);
  }

  function qv2ShowStep(stepNumber) {
    if (window.QV2 && typeof window.QV2.showStep === 'function') {
      window.QV2.showStep(stepNumber);
    }
  }

  function getWeddingDateValue() {
    if (window.QV2_WEDDING_DATE && typeof window.QV2_WEDDING_DATE.get === 'function') {
      const fromBridge = window.QV2_WEDDING_DATE.get();
      if (fromBridge) return fromBridge;
    }

    let raw = '';

    const storeEl = document.getElementById('qv2-wedding-date-store');
    if (storeEl && storeEl.value) raw = storeEl.value.trim();

    if (!raw) {
      raw = (document.body.getAttribute('data-qv2-wedding-date') || '').trim();
    }

    if (!raw && window.QV2 && typeof window.QV2.forceFlushWeddingDateInput === 'function') {
      raw = window.QV2.forceFlushWeddingDateInput() || '';
    }

    if (!raw && window.QV2 && typeof window.QV2.captureWeddingDateSnapshot === 'function') {
      raw = window.QV2.captureWeddingDateSnapshot() || '';
    }

    if (!raw) {
      const step1Input = document.getElementById('qv2-wedding-date');
      if (step1Input && step1Input.value) raw = step1Input.value.trim();
    }

    if (!raw) {
      const host = document.querySelector('[data-qv2-steps-host]');
      if (host) {
        const hostInput = host.querySelector(
          '[data-step="1"] #qv2-wedding-date, [data-step="1"] input[name="wedding-date"]'
        );
        if (hostInput && hostInput.value) raw = hostInput.value.trim();
      }
    }

    if (!raw) {
      try {
        raw = sessionStorage.getItem('qv2-wedding-date') ||
          localStorage.getItem('qv2-wedding-date') ||
          '';
      } catch (e) {
        raw = '';
      }
    }

    return raw;
  }

  function formatWeddingDateFrench(isoDate) {
    if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return isoDate || '—';
    const parts = isoDate.split('-');
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  function syncAccountWeddingDateField(skipValidation) {
    if (window.QV2_WEDDING_DATE && typeof window.QV2_WEDDING_DATE.syncStep17 === 'function') {
      window.QV2_WEDDING_DATE.syncStep17();
      if (!skipValidation) requestAccountFormValidation();
      return;
    }

    const mainDate = getWeddingDateValue();
    const hiddenDate = document.getElementById('RegisterForm-WeddingDate');
    const displayDate = document.getElementById('account-wedding-date-display');
    const recapWrap = document.getElementById('account-wedding-date-recap');
    const formatted = mainDate ? formatWeddingDateFrench(mainDate) : '';

    if (hiddenDate) {
      hiddenDate.value = mainDate;
      hiddenDate.readOnly = true;
    }
    if (displayDate) {
      displayDate.textContent = formatted || '—';
    }
    if (recapWrap) {
      recapWrap.classList.toggle('form-field-invalid', !mainDate);
    }
    if (!skipValidation) requestAccountFormValidation();
  }

  function requestAccountFormValidation() {
    if (typeof window.__qv2ValidateCreateAccountForm === 'function') {
      window.__qv2ValidateCreateAccountForm();
    }
  }

  document.addEventListener('qv2:accountFormValidate', requestAccountFormValidation);

  function setValidationButtonState(button, disabled) {
    if (!button) return;
    button.disabled = !!disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function syncQV2State() {
    const s0204 = (window.QV2_STEPS_02_04 && window.QV2_STEPS_02_04.getState) ? window.QV2_STEPS_02_04.getState() : {};
    const s0508 = (window.QV2_STEPS_05_08 && window.QV2_STEPS_05_08.getState) ? window.QV2_STEPS_05_08.getState() : {};
    const s0913 = (window.QV2_STEPS_09_13 && window.QV2_STEPS_09_13.getState) ? window.QV2_STEPS_09_13.getState() : {};
    if (s0508.demoisellesChoice !== undefined) demoisellesChoice = s0508.demoisellesChoice;
    if (s0508.demoisellesQuantity !== undefined) demoisellesQuantity = s0508.demoisellesQuantity;
    if (s0508.tablesQuantity !== undefined) tablesQuantity = s0508.tablesQuantity;
    if (s0913.tableHonneurChoice !== undefined) tableHonneurChoice = s0913.tableHonneurChoice;
    if (s0913.tableHonneurPrice !== undefined) tableHonneurPrice = s0913.tableHonneurPrice;
    if (s0913.archeChoice !== undefined) archeChoice = s0913.archeChoice;
    if (s0913.archePrice !== undefined) archePrice = s0913.archePrice;
    if (s0913.chairChoice !== undefined) chairChoice = s0913.chairChoice;
    if (s0913.chairQuantity !== undefined) chairQuantity = s0913.chairQuantity;
    if (s0913.chairPrice !== undefined) chairPrice = s0913.chairPrice;
    if (Array.isArray(s0204.selectedBouquets)) selectedBouquets = s0204.selectedBouquets;
  }

  function loadQuestionnaireConfig() {
    if (window.questionnaireConfig && window.questionnaireConfig.timeRates) {
      mergeDevisNotificationConfig();
      return window.questionnaireConfig;
    }
    const el = document.getElementById('qv2-questionnaire-config-data');
    if (!el) {
      mergeDevisNotificationConfig();
      return window.questionnaireConfig || {};
    }
    try {
      window.questionnaireConfig = JSON.parse(el.textContent);
      try {
        window.questionnaireConfig.cartVariants = JSON.parse(window.questionnaireConfig.cartVariantsRaw || '{}');
      } catch (e) {
        window.questionnaireConfig.cartVariants = {};
      }
      mergeDevisNotificationConfig();
      if (
        window.questionnaireConfig.cartVariantsAssetUrl &&
        (!window.questionnaireConfig.cartVariants || !Object.keys(window.questionnaireConfig.cartVariants).length)
      ) {
        fetch(window.questionnaireConfig.cartVariantsAssetUrl)
          .then(function (r) { return r.ok ? r.json() : {}; })
          .then(function (cv) {
            window.questionnaireConfig.cartVariants = cv || {};
            document.dispatchEvent(new CustomEvent('questionnaire:cartVariantsLoaded'));
          })
          .catch(function () {});
      }
    } catch (e) {
      window.questionnaireConfig = {};
      mergeDevisNotificationConfig();
    }
    return window.questionnaireConfig;
  }

  function mergeDevisNotificationConfig() {
    if (!window.questionnaireConfig) window.questionnaireConfig = {};
    const notifEl = document.getElementById('qv2-devis-notification-data');
    if (!notifEl) return;
    try {
      window.questionnaireConfig.devisNotification = JSON.parse(notifEl.textContent);
    } catch (e) {
      window.questionnaireConfig.devisNotification = {};
    }
  }

/* ============================================
       ÉTAPE 18 - RÉSUMÉ FINAL
       ============================================ */
    const FRESH_COLLAPSED_COUNT = 2;
    const SUPP_COLLAPSED_COUNT = 2;
    const SNAPSHOT_STORAGE_KEY = 'floreasy_qv2_questionnaire_snapshot_v2';
    const DEVIS_NOTIF_SENT_KEY = 'qv2-devis-notif-sent';
  /* SVG placeholder en base64 (évite les " dans data:… qui cassent src="…") */
    const PLACEHOLDER_IMG =
      'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjZjBlOWQ2Ii8+PHBhdGggZD0iTTMwIDE4YTggOCAwIDEwMCAxNiA4IDggMCAwMDAtMTZ6bS0xMiAyOGExMiAxMiAwIDAgMSAyNCAweiIgZmlsbD0iIzhCMTUzOCIgb3BhY2l0eT0iLjM1Ii8+PC9zdmc+';

    function escapeHtmlAttr(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function getSummaryImageFromEl(root) {
      if (!root) {
        return '';
      }
      const img = root.querySelector(
        '.table-honneur-image img, .accessory-item-image img, .container-item-image img, .yes-no-image img, .bouquet-item-image img, .element-item-image img, .decoration-item-image img, img'
      );
      if (img) {
        const fromImg = (
          img.getAttribute('src') ||
          img.getAttribute('data-fallback-src') ||
          img.getAttribute('data-lightbox-src') ||
          ''
        ).trim();
        if (fromImg && fromImg.indexOf('data:') !== 0) {
          return fromImg;
        }
      }
      const thumbPipe = root.getAttribute('data-step11-images-thumb') ||
        root.getAttribute('data-step10-images-thumb') ||
        root.getAttribute('data-product-images-thumb') ||
        '';
      const firstThumb = thumbPipe ? thumbPipe.split('|||')[0].trim() : '';
      return (
        root.getAttribute('data-q-thumb') ||
        firstThumb ||
        root.getAttribute('data-q-full') ||
        ''
      ).trim();
    }

    /* ----------- Persistence (snapshot) ----------- */
    function captureSummarySnapshot() {
      try {
        return {
          customerFirstName: (document.getElementById('RegisterForm-FirstName') || {}).value || '',
          customerLastName:  (document.getElementById('RegisterForm-LastName')  || {}).value || '',
          email:             (document.getElementById('RegisterForm-email')     || {}).value || '',
          weddingDate: getWeddingDateValue(),
          postalCode:        (document.getElementById('RegisterForm-PostalCode') || {}).value || '',
          participants:      (workshopParticipantsInput() || {}).value || '0',
          totalMinutes:      computeTotalTimeMinutes(),
          freshItems:        getFreshItems(),
          supplements:       getSupplementsItems(),
          pack:              getRecommendedPackInfo(),
          savedAt:           Date.now()
        };
      } catch (e) {
        console.warn('captureSummarySnapshot error:', e);
        return null;
      }
    }

    function saveSummarySnapshot() {
      try {
        const snap = captureSummarySnapshot();
        if (snap) localStorage.setItem(SNAPSHOT_STORAGE_KEY, JSON.stringify(snap));
      } catch (e) {
        // localStorage indisponible / quota — on continue silencieusement
      }
    }

    function loadSummarySnapshot() {
      try {
        const raw = localStorage.getItem(SNAPSHOT_STORAGE_KEY);
        if (!raw) return null;
        const snap = JSON.parse(raw);
        // Snapshot valide ~24h
        if (!snap || !snap.savedAt || (Date.now() - snap.savedAt) > 86400000) {
          localStorage.removeItem(SNAPSHOT_STORAGE_KEY);
          return null;
        }
        return snap;
      } catch (e) {
        return null;
      }
    }

    function clearSummarySnapshot() {
      try { localStorage.removeItem(SNAPSHOT_STORAGE_KEY); } catch (e) {}
    }

    // Exposer pour le hook dans showStep
    window.saveSummarySnapshot = saveSummarySnapshot;

    function getTimeRates() {
      return (window.questionnaireConfig && window.questionnaireConfig.timeRates) || {};
    }

    function formatDuration(totalMinutes) {
      const mins = Math.max(0, Math.round(totalMinutes || 0));
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      if (h > 0 && m > 0) return h + 'h' + String(m).padStart(2, '0') + 'min';
      if (h > 0)          return h + 'h';
      return m + 'min';
    }

    function getSelectedBouquetTitles() {
      const titles = [];
      document.querySelectorAll('.bouquet-item.selected').forEach(el => {
        const label = el.querySelector('.bouquet-item-label');
        if (label) titles.push(label.textContent.trim());
      });
      return titles;
    }

    function getSelectedVinHonneurElements() {
      const els = [];
      document.querySelectorAll('.element-item.selected').forEach(el => {
        const labelEl = el.querySelector('.element-item-label');
        const imgEl = el.querySelector('.element-item-image img');
        const flowers = parseInt(el.getAttribute('data-element-flowers'), 10) || 0;
        els.push({
          title: labelEl ? labelEl.textContent.trim() : '',
          flowers,
          image: imgEl ? imgEl.src : ''
        });
      });
      return els;
    }

    function getSelectedDecorationInfo() {
      const el = document.querySelector('.decoration-item.selected');
      if (!el) return null;
      const titleAttr = el.getAttribute('data-decoration-title') || '';
      const labelEl = el.querySelector('.decoration-item-label');
      const imgEl = el.querySelector('.decoration-item-image img');
      const multiplier = parseInt(el.getAttribute('data-decoration-multiplier'), 10) || 1;
      const normalized = titleAttr.toLowerCase();
      let kind = 'autre';
      if (normalized.includes('soliflore')) kind = 'soliflore';
      else if (normalized.includes('vase')) kind = 'vase';
      else if (normalized.includes('piqu') || normalized.includes('coupelle') || normalized.includes('dorée') || normalized.includes('doree'))  kind = 'pique';
      return {
        kind,
        title: titleAttr || (labelEl ? labelEl.textContent.trim() : ''),
        multiplier,
        image: imgEl ? imgEl.src : ''
      };
    }

    function parsePriceFromText(text) {
      const match = String(text || '').match(/(\d+(?:[.,]\d+)?)/);
      return match ? parseFloat(match[1].replace(',', '.')) : 0;
    }

    function getExtraBundles() {
      if (window.QV2_STEPS_16 && typeof window.QV2_STEPS_16.getFlowerBundlesForSummary === 'function') {
        const fromState = window.QV2_STEPS_16.getFlowerBundlesForSummary();
        if (fromState.length) return fromState;
      }
      // Étape 16 - bottes de fleurs supplémentaires (fleurs fraîches en supplément)
      const bundles = [];
      document.querySelectorAll('.flowers-variety-item').forEach(card => {
        const qtyEl = card.querySelector('.flower-variety-bundles-value');
        const qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.flower-variety-name, .flowers-variety-name, .variety-name');
        const imgEl = card.querySelector('img');
        bundles.push({
          title: nameEl ? nameEl.textContent.trim() : 'Botte de fleurs',
          quantity: qty,
          image: imgEl ? imgEl.src : ''
        });
      });
      return bundles;
    }

    function getExtraBundlesForSupplements() {
      if (window.QV2_STEPS_16 && typeof window.QV2_STEPS_16.getFlowerBundlesForSummary === 'function') {
        const fromState = window.QV2_STEPS_16.getFlowerBundlesForSummary();
        if (fromState.length) {
          return fromState.map(function (b) {
            return {
              title: ('BOTTE ' + (b.title || 'FLEURS')).toUpperCase(),
              quantity: b.quantity,
              unitPrice: parsePriceFromText(b.price || ''),
              image: b.image || ''
            };
          });
        }
      }
      const items = [];
      document.querySelectorAll('.flowers-variety-item').forEach(card => {
        const qtyEl = card.querySelector('.flower-variety-bundles-value');
        const qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.flower-variety-name');
        const priceEl = card.querySelector('.flower-variety-price');
        const imgEl = card.querySelector('img');
        items.push({
          title: ('BOTTE ' + (nameEl ? nameEl.textContent.trim() : 'FLEURS')).toUpperCase(),
          quantity: qty,
          unitPrice: parsePriceFromText(priceEl ? priceEl.textContent : ''),
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getAccessoriesItems() {
      // Étape 12 - accessoires fleuris stabilisés
      const items = [];
      document.querySelectorAll('.step12-accessories-option.selected').forEach(el => {
        const accessoryId = el.getAttribute('data-accessory-id');
        const qtyInput = el.querySelector('#accessory-quantity-' + accessoryId)
          || el.querySelector('.quantity-input[data-accessory-id="' + accessoryId + '"]');
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const labelEl = el.querySelector('.table-honneur-title');
        const imgEl = el.querySelector('img');
        const priceEl = el.querySelector('.accessories-price');
        let unitPrice = parsePriceFromText(priceEl ? priceEl.textContent : '');
        if (!unitPrice) {
          const colorSelect = el.querySelector('.accessories-color-select');
          if (colorSelect && colorSelect.selectedOptions.length) {
            unitPrice = parseFloat(colorSelect.selectedOptions[0].getAttribute('data-price')) || 0;
          }
        }
        if (!unitPrice) {
          unitPrice = parseFloat(el.getAttribute('data-accessory-first-price')) || 0;
        }

        items.push({
          title: labelEl ? labelEl.textContent.trim() : 'Accessoire',
          quantity: qty,
          unitPrice: unitPrice,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getContainersItems() {
      const items = [];
      document.querySelectorAll('.container-item').forEach(el => {
        const containerId = el.getAttribute('data-container-id');
        const qtyInput = el.querySelector('#container-quantity-' + containerId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const labelEl = el.querySelector('.container-item-label');
        const imgEl = el.querySelector('img');
        const unitPrice = parseFloat(el.getAttribute('data-container-price')) || 0;
        items.push({
          title: labelEl ? labelEl.textContent.trim() : 'Contenant',
          quantity: qty,
          unitPrice: unitPrice,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getGiftBagItems() {
      const items = [];
      document.querySelectorAll('.gift-bag-item').forEach(el => {
        const bagId = el.getAttribute('data-gift-bag-id');
        const qtyInput = el.querySelector('#gift-bag-quantity-' + bagId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const labelEl = el.querySelector('.gift-bag-item-label');
        const imgEl = el.querySelector('img');
        const unitPrice = parseFloat(el.getAttribute('data-gift-bag-price')) || 0;
        items.push({
          title: labelEl ? labelEl.textContent.trim() : 'Sac cadeau',
          quantity: qty,
          unitPrice: unitPrice,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getMaterialsItems() {
      // Étape 15 - matériels d'atelier
      const items = [];
      document.querySelectorAll('.material-item').forEach(card => {
        const qInput = card.querySelector('.quantity-input[data-material-id]');
        if (!qInput) return;
        const qty = parseInt(qInput.value, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.material-item-title, .material-item-name, .material-name');
        const priceAttr = card.getAttribute('data-material-price') || card.getAttribute('data-price') || '0';
        const price = parseFloat(String(priceAttr).replace(',', '.')) || 0;
        const imgEl = card.querySelector('img');
        items.push({
          title: nameEl ? nameEl.textContent.trim() : 'Matériel',
          quantity: qty,
          unitPrice: price,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    /* ----------- Calcul du temps total ----------- */
    function computeTotalTimeMinutes() {
      syncQV2State();
      const R = getTimeRates();
      let total = 0;

      // Étape 4 - Bouquets
      const bouquetTitles = getSelectedBouquetTitles().map(t => t.toLowerCase());
      if (bouquetTitles.some(t => t.includes('mari'))) total += R.bouquetMariee || 0;
      if (bouquetTitles.some(t => t.includes('lancer'))) total += R.bouquetLancer || 0;

      // Étape 5 - Demoiselles d'honneur
      if (typeof demoisellesChoice !== 'undefined' && demoisellesChoice === 'yes') {
        total += (demoisellesQuantity || 0) * (R.bouquetDemoiselle || 0);
      }

      // Étape 6 - Vin d'honneur
      getSelectedVinHonneurElements().forEach(el => {
        const t = el.title.toLowerCase();
        if (t.includes('traiteur'))   total += R.tableTraiteur    || 0;
        if (t.includes('bienvenue'))  total += R.tableauBienvenue || 0;
        if (t.includes('haute'))      total += R.tableHaute       || 0;
      });

      // Étape 7 - Centres de table
      const deco = getSelectedDecorationInfo();
      const nbTables = (typeof tablesQuantity !== 'undefined') ? (parseInt(tablesQuantity, 10) || 0) : 0;
      if (deco && nbTables > 0) {
        if (deco.kind === 'soliflore') {
          const nbSoliflores = nbTables * (deco.multiplier || 6);
          total += Math.ceil(nbSoliflores / 3) * (R.soliflore || 0);
        } else if (deco.kind === 'vase') {
          total += nbTables * (R.vase || 0);
        } else if (deco.kind === 'pique') {
          total += nbTables * (R.pique || 0);
        }
      }

      // Étape 9 - Table d'honneur (uniquement fresh)
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'fresh') {
        total += R.tableHonneur || 0;
      }

      // Étape 10 - Arche (uniquement fresh)
      if (typeof archeChoice !== 'undefined' && archeChoice === 'fresh') {
        total += R.arche || 0;
      }

      // Étape 11 - Bouquets de chaise (uniquement fresh)
      if (typeof chairChoice !== 'undefined' && chairChoice === 'fresh') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        total += nbChairs * (R.chaise || 0);
      }

      return total;
    }

    function computeCreationDurationMinutes() {
      const totalMins = computeTotalTimeMinutes();
      const participantsRaw = (workshopParticipantsInput() && workshopParticipantsInput().value) || '0';
      const participants = Math.max(1, parseInt(participantsRaw, 10) || 1);
      return Math.round(totalMins / participants);
    }

    /* ----------- Items "fleurs fraîches" (Pour rappel) ----------- */
    function getFreshItems() {
      syncQV2State();
      const items = [];

      // Étape 4 - bouquets sélectionnés
      document.querySelectorAll('.bouquet-item.selected').forEach(el => {
        const label = el.querySelector('.bouquet-item-label');
        const flowers = parseInt(el.getAttribute('data-bouquet-flowers'), 10) || 0;
        items.push({
          title: label ? label.textContent.trim() : 'BOUQUET',
          flowers,
          image: getSummaryImageFromEl(el)
        });
      });

      // Étape 5 - demoiselles d'honneur
      if (typeof demoisellesChoice !== 'undefined' && demoisellesChoice === 'yes' && demoisellesQuantity > 0) {
        items.push({
          title: 'BOUQUETS DEMOISELLES D\'HONNEUR (×' + demoisellesQuantity + ')',
          flowers: 10 * demoisellesQuantity,
          image: getSummaryImageFromEl(document.getElementById('yes-option'))
        });
      }

      // Étape 6 - vin d'honneur (toujours fresh)
      getSelectedVinHonneurElements().forEach(el => {
        items.push({ title: el.title.toUpperCase(), flowers: el.flowers, image: el.image });
      });

      // Étape 7 - centre de table (DIY uniquement)
      const deco = getSelectedDecorationInfo();
      const nbTables = (typeof tablesQuantity !== 'undefined') ? (parseInt(tablesQuantity, 10) || 0) : 0;
      if (deco && nbTables > 0) {
        const labelMap = { soliflore: 'CENTRE DE TABLE SOLIFLORES', vase: 'CENTRE DE TABLE VASES', pique: 'CENTRES COUPELLES DORÉES' };
        items.push({
          title: labelMap[deco.kind] || ('CENTRE DE TABLE ' + (deco.title || '').toUpperCase()),
          flowers: nbTables * (deco.multiplier || 0),
          image: deco.image
        });
      }

      // Étape 9 - table d'honneur fresh uniquement
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'fresh') {
        const thFreshImg = getSummaryImageFromEl(document.getElementById('table-honneur-fresh'));
        items.push({ title: 'COMPOSITION TABLE D\'HONNEUR', flowers: 25, image: thFreshImg });
      }

      // Étape 10 - arche fresh uniquement
      if (typeof archeChoice !== 'undefined' && archeChoice === 'fresh') {
        items.push({
          title: 'ARCHE FLEURIE',
          flowers: (typeof archeFlowers !== 'undefined' ? archeFlowers : 0) || 50,
          image: getSummaryImageFromEl(document.getElementById('arche-fresh'))
        });
      }

      // Étape 11 - chaises fresh uniquement
      if (typeof chairChoice !== 'undefined' && chairChoice === 'fresh') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        if (nbChairs > 0) {
          const chairFreshImg = getSummaryImageFromEl(document.getElementById('step11-fresh-option'));
          items.push({
            title: 'BOUQUETS DE CHAISE (×' + nbChairs + ')',
            flowers: 5 * nbChairs,
            image: chairFreshImg
          });
        }
      }

      // Étape 16 - bottes supplémentaires fresh
      getExtraBundles().forEach(b => {
        items.push({ title: ('BOTTE ' + b.title).toUpperCase(), flowers: b.quantity * 5, image: b.image });
      });

      return items;
    }

    /* ----------- Items "Suppléments" (artificiels, stabilisés, contenants…) ----------- */
    function getSupplementsItems() {
      syncQV2State();
      const items = [];

      // Étape 9 - table d'honneur artificielle
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'artificial') {
        const price = parseFloat(((window.questionnaireConfig && window.questionnaireConfig.step9ArtificialPrice) || tableHonneurPrice) || 0) || 0;
        const thImg = getSummaryImageFromEl(document.getElementById('table-honneur-artificial'));
        items.push({ title: 'TABLE D\'HONNEUR ARTIFICIELLE', quantity: 1, unitPrice: price, image: thImg });
      }

      // Étape 10 - arche artificielle
      if (typeof archeChoice !== 'undefined' && archeChoice === 'artificial') {
        const price = parseFloat(((typeof archePrice !== 'undefined') ? archePrice : 0)) || 0;
        const archeImg =
          getSummaryImageFromEl((function() {
            const g = document.querySelector('.arche-color-gallery:not([hidden])');
            return g ? g.querySelector('.arche-color-image-swiper-container') || g : null;
          })()) ||
          getSummaryImageFromEl(document.getElementById('arche-artificial'));
        items.push({ title: 'ARCHE FLEURIE ARTIFICIELLE', quantity: 1, unitPrice: price, image: archeImg });
      }

      // Étape 11 - chaises artificielles
      if (typeof chairChoice !== 'undefined' && chairChoice === 'artificial') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        const unit = parseFloat(chairPrice || 0) || 0;
        if (nbChairs > 0) {
          const chairImg = getSummaryImageFromEl(document.getElementById('step11-artificial-option'));
          items.push({ title: 'BOUQUETS DE CHAISE ARTIFICIELS', quantity: nbChairs, unitPrice: unit, image: chairImg });
        }
      }

      // Étape 12 - accessoires stabilisés
      getAccessoriesItems().forEach(it => items.push(it));

      // Étape 13 - contenants & sacs cadeaux
      getContainersItems().forEach(it => items.push(it));

      // Étape 15 - matériels
      getMaterialsItems().forEach(it => items.push(it));

      // Étape 16 - bottes supplémentaires (hors pack DIY)
      getExtraBundlesForSupplements().forEach(it => items.push(it));

      // Étape 13 - sacs cadeaux
      getGiftBagItems().forEach(it => items.push(it));

      return items;
    }

    /* ----------- Pack DIY recommandé (S / M / L selon quantité de fleurs) ----------- */
    const PACK_STEMS_S = 186;
    const PACK_STEMS_M = 280;
    const PACK_PRICE_M_RATIO = 1242 / 796;
    const PACK_PRICE_L_RATIO = 1716 / 796;

    function getRecommendedPackInfo() {
      const freshItems = getFreshItems();
      const totalFlowers = freshItems.reduce(function(sum, it) {
        return sum + (parseInt(it.flowers, 10) || 0);
      }, 0);

      const universEl = document.querySelector('.univers-item.selected');
      const universTitle = universEl ? (universEl.getAttribute('data-univers-title') || '').trim() : '';
      const universPriceEl = universEl ? universEl.querySelector('.univers-item-price') : null;
      const basePrice = parsePriceFromText(universPriceEl ? universPriceEl.textContent : '');

      let packSize = 'S';
      let unitPrice = basePrice;
      if (totalFlowers > PACK_STEMS_M) {
        packSize = 'L';
        unitPrice = basePrice * PACK_PRICE_L_RATIO;
      } else if (totalFlowers > PACK_STEMS_S) {
        packSize = 'M';
        unitPrice = basePrice * PACK_PRICE_M_RATIO;
      }

      const packName = universTitle
        ? ('PACK DIY ' + packSize + ' — ' + universTitle)
        : (totalFlowers > 0 ? ('PACK DIY ' + packSize) : '-');

      const packImageEl = universEl ? universEl.querySelector('.univers-item-image img') : null;
      const image = (packImageEl && packImageEl.src) ? packImageEl.src : '';

      return {
        name: packName,
        size: packSize,
        unitPrice: Math.round(unitPrice * 100) / 100,
        image: image,
        quantity: 1,
        totalFlowers: totalFlowers
      };
    }

    /* ----------- Rendu HTML ----------- */
    const VAT_RATE = 0; // TVA désactivée (0%).

    function toTtcPrice(value) {
      const numeric = parseFloat(value) || 0;
      return Math.round((numeric * (1 + VAT_RATE)) * 100) / 100;
    }

    function renderFreshList() {
      const container = document.getElementById('summary-items-list-short');
      const seeAllLink = document.getElementById('summary-see-all-fresh-link');
      if (!container) return;

      const items = (getSummaryData() || {}).freshItems || [];
      const expanded = container.getAttribute('data-expanded') === 'true';
      const visible = expanded ? items : items.slice(0, FRESH_COLLAPSED_COUNT);

      if (items.length === 0) {
        container.innerHTML = '<div class="summary-empty-state">Aucun élément en fleurs fraîches sélectionné.</div>';
        if (seeAllLink) seeAllLink.style.display = 'none';
        return;
      }

      container.innerHTML = visible.map(item => {
        const imgSrc = escapeHtmlAttr(item.image || PLACEHOLDER_IMG);
        return ''
          + '<div class="summary-fresh-item">'
          +   '<div class="summary-fresh-item-image"><img src="' + imgSrc + '" alt="" loading="lazy"/></div>'
          +   '<div class="summary-fresh-item-name">' + escapeHtmlAttr(item.title) + '</div>'
          +   '<div class="summary-fresh-item-badge">+ ' + item.flowers + ' fleurs</div>'
          + '</div>';
      }).join('');

      if (seeAllLink) {
        if (items.length > FRESH_COLLAPSED_COUNT) {
          seeAllLink.style.display = '';
          seeAllLink.innerHTML = expanded ? 'Voir moins <span>▲</span>' : 'Voir tout <span>▼</span>';
        } else {
          seeAllLink.style.display = 'none';
        }
      }
    }

    function renderItemsTable(tbodyId, items, collapsedCount) {
      const tbody = document.getElementById(tbodyId);
      if (!tbody) return 0;

      if (items.length === 0) {
        tbody.innerHTML = '<tr class="summary-empty-row"><td colspan="5">Aucun élément</td></tr>';
        return 0;
      }

      const expanded = tbody.getAttribute('data-expanded') === 'true';
      const visible = expanded ? items : items.slice(0, collapsedCount);

      let totalAmount = 0;
      items.forEach(function(it) {
        const lineHt = (it.unitPrice || 0) * (it.quantity || 0);
        totalAmount += toTtcPrice(lineHt);
      });

      tbody.innerHTML = visible.map(it => {
        const imgSrc = escapeHtmlAttr(it.image || PLACEHOLDER_IMG);
        const lineHt = (it.unitPrice || 0) * (it.quantity || 0);
        const unitTtc = toTtcPrice(it.unitPrice || 0);
        const totalTtc = toTtcPrice(lineHt);
        const unitStr  = (it.unitPrice > 0) ? formatPrice(unitTtc) : '—';
        const totalStr = (it.unitPrice > 0) ? formatPrice(totalTtc) : '—';
        return ''
          + '<tr class="summary-item-row">'
          +   '<td class="summary-col-image"><img src="' + imgSrc + '" alt="" loading="lazy"/></td>'
          +   '<td class="summary-col-name">' + escapeHtmlAttr(it.title) + '</td>'
          +   '<td class="summary-col-qty">' + (it.quantity || 0) + '</td>'
          +   '<td class="summary-col-unit">' + unitStr + '</td>'
          +   '<td class="summary-col-total">' + totalStr + '</td>'
          + '</tr>';
      }).join('');

      return totalAmount;
    }

    function formatPrice(value) {
      const v = Math.round((value || 0) * 100) / 100;
      const s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
      return s + ' € TTC';
    }

    /* ----------- Données affichées (live DOM OU snapshot localStorage) ----------- */
    // Cache local pour mémoriser les items fresh/supp/pack quand on déplie/replie
    let summaryDataCache = null;

    function getSummaryData() {
      syncQV2State();
      if (summaryDataCache) return summaryDataCache;

      const snap = loadSummarySnapshot();
      let data;

      // Si la page a rechargé après création de compte, les variables d'état JS sont perdues
      // → on utilise le snapshot. Sinon on lit le DOM live.
      const hasLiveState = (typeof selectedBouquets !== 'undefined' && selectedBouquets.length > 0)
        || (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice !== null)
        || (typeof archeChoice !== 'undefined' && archeChoice !== null)
        || (typeof chairChoice !== 'undefined' && chairChoice !== null)
        || (workshopParticipantsInput() && workshopParticipantsInput().value)
        || document.querySelectorAll('.bouquet-item.selected, .element-item.selected, .decoration-item.selected').length > 0;

      if (snap && !hasLiveState) {
        data = {
          firstName: snap.customerFirstName || '',
          lastName: snap.customerLastName || '',
          email: snap.email || '',
          weddingDate: snap.weddingDate || '',
          postalCode: snap.postalCode || '',
          participants: Math.max(1, parseInt(snap.participants, 10) || 1),
          totalMinutes: snap.totalMinutes || 0,
          freshItems: Array.isArray(snap.freshItems) ? snap.freshItems : [],
          supplements: Array.isArray(snap.supplements) ? snap.supplements : [],
          pack: snap.pack || { name: '-', quantity: 1, unitPrice: 0, image: '' },
          source: 'snapshot'
        };
      } else {
        const participantsRaw = (workshopParticipantsInput() && workshopParticipantsInput().value) || '0';
        data = {
          firstName: (document.getElementById('RegisterForm-FirstName') || {}).value || '',
          lastName:  (document.getElementById('RegisterForm-LastName')  || {}).value || '',
          email:     (document.getElementById('RegisterForm-email')     || {}).value || '',
          weddingDate: getWeddingDateValue() || '',
          postalCode:  (document.getElementById('RegisterForm-PostalCode') || {}).value || '',
          participants: Math.max(1, parseInt(participantsRaw, 10) || 1),
          totalMinutes: computeTotalTimeMinutes(),
          freshItems: getFreshItems(),
          supplements: getSupplementsItems(),
          pack: getRecommendedPackInfo(),
          source: 'live'
        };
      }

      summaryDataCache = data;
      return data;
    }

    function invalidateSummaryCache() {
      summaryDataCache = null;
    }

    /* ----------- Orchestration principale ----------- */
    function populateSummary() {
      invalidateSummaryCache();
      const data = getSummaryData();

      // Nom personnalisé
      const nameEl = document.getElementById('summary-customer-name');
      if (nameEl) {
        const fn = (data.firstName || '').trim();
        nameEl.textContent = (fn ? fn.toUpperCase() : (nameEl.textContent || 'CLIENT')).replace(/,$/, '') + ',';
      }

      // Participants & durée
      const partEl = document.getElementById('summary-participants-count');
      if (partEl) partEl.textContent = data.participants;

      const durationMinutes = Math.round((data.totalMinutes || 0) / Math.max(1, data.participants));
      const durationEl = document.getElementById('summary-creation-duration');
      if (durationEl) durationEl.textContent = formatDuration(durationMinutes);

      // Quantité totale de fleurs
      const totalFlowers = data.freshItems.reduce(function(sum, it) { return sum + (parseInt(it.flowers, 10) || 0); }, 0);
      const totalFlowersEl = document.getElementById('summary-total-flowers');
      if (totalFlowersEl) totalFlowersEl.textContent = totalFlowers;

      // Pack DIY recommandé (affichage en-tête)
      const pack = data.pack;
      const recPackEl = document.getElementById('summary-recommended-pack');
      if (recPackEl) recPackEl.textContent = (pack && pack.size) ? pack.size : '-';

      // Liste "Pour rappel" (fresh only)
      renderFreshList();

      // Tableau "Kit de fleurs fraîche" (1 ligne : le pack recommandé)
      const freshTableItems = (pack && pack.name && pack.name !== '-')
        ? [{ title: pack.name, quantity: pack.quantity, unitPrice: pack.unitPrice, image: pack.image }]
        : [];
      const kitTotal = renderItemsTable('summary-table-fresh-body', freshTableItems, freshTableItems.length);

      // Tableau "Suppléments"
      const suppTbody = document.getElementById('summary-table-supplements-body');
      const suppSeeAll = document.getElementById('summary-see-all-supplements-link');
      const suppTotal = renderItemsTable('summary-table-supplements-body', data.supplements, SUPP_COLLAPSED_COUNT);
      if (suppSeeAll) {
        if (data.supplements.length > SUPP_COLLAPSED_COUNT) {
          suppSeeAll.style.display = '';
          const expanded = suppTbody && suppTbody.getAttribute('data-expanded') === 'true';
          suppSeeAll.innerHTML = expanded ? 'Voir moins <span>▲</span>' : 'Voir tout <span>▼</span>';
        } else {
          suppSeeAll.style.display = 'none';
        }
      }

      // Budget total = kit + suppléments
      const totalBudgetEl = document.getElementById('summary-total-budget');
      if (totalBudgetEl) totalBudgetEl.textContent = formatPrice(kitTotal + suppTotal);

      updateCartButtonState();
    }

    // Exposer pour le hook dans showStep
    window.populateSummary = populateSummary;

    /* ----------- Voir tout / Voir moins ----------- */
    safeAddEventListener(getElement('summary-see-all-fresh-link'), 'click', function(e) {
      e.preventDefault();
      const container = document.getElementById('summary-items-list-short');
      if (!container) return;
      container.setAttribute('data-expanded', container.getAttribute('data-expanded') === 'true' ? 'false' : 'true');
      renderFreshList();
    });

    safeAddEventListener(getElement('summary-see-all-supplements-link'), 'click', function(e) {
      e.preventDefault();
      const tbody = document.getElementById('summary-table-supplements-body');
      if (!tbody) return;
      tbody.setAttribute('data-expanded', tbody.getAttribute('data-expanded') === 'true' ? 'false' : 'true');
      populateSummary();
    });

    /* ----------- Modale "Comment ce temps est-il calculé ?" ----------- */
    const timeHelpModal = document.getElementById('time-help-modal');
    function openTimeHelpModal() {
      if (!timeHelpModal) return;
      timeHelpModal.classList.add('active');
      timeHelpModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeTimeHelpModal() {
      if (!timeHelpModal) return;
      timeHelpModal.classList.remove('active');
      timeHelpModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    safeAddEventListener(getElement('summary-time-help-link'), 'click', function(e) {
      e.preventDefault();
      openTimeHelpModal();
    });
    safeAddEventListener(getElement('time-help-modal-close'), 'click', closeTimeHelpModal);
    if (timeHelpModal) {
      const overlay = timeHelpModal.querySelector('.modal-overlay');
      safeAddEventListener(overlay, 'click', closeTimeHelpModal);
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && timeHelpModal && timeHelpModal.classList.contains('active')) {
        closeTimeHelpModal();
      }
    });

    /* ----------- Génération PDF du devis ----------- */
    const PDF_INLINE_STYLES = ''
      + '#pdf-export-content,#pdf-export-content .pdf-page{background:#fff;color:#000;font-family:Arial,Helvetica,sans-serif;}'
      + '#pdf-export-content{width:794px;padding:36px 32px 36px 44px;box-sizing:border-box;}'
      + '#pdf-export-content .pdf-page{padding:4px 2px;box-sizing:border-box;}'
      + '#pdf-export-content .pdf-header{display:flex;align-items:center;gap:20px;padding-bottom:15px;border-bottom:2px solid #8B1538;margin-bottom:20px;}'
      + '#pdf-export-content .pdf-logo{height:60px;width:auto;object-fit:contain;}'
      + '#pdf-export-content .pdf-title{font-size:22px;font-weight:700;color:#8B1538;text-transform:uppercase;}'
      + '#pdf-export-content .pdf-section{margin-bottom:20px;}'
      + '#pdf-export-content .pdf-section h2{font-size:14px;font-weight:700;color:#8B1538;text-transform:uppercase;margin:0 0 10px;padding-bottom:5px;border-bottom:1px solid #e5d6dc;}'
      + '#pdf-export-content .pdf-info-table{width:100%;border-collapse:collapse;font-size:13px;}'
      + '#pdf-export-content .pdf-info-table td{padding:6px 12px 6px 4px;vertical-align:top;}'
      + '#pdf-export-content .pdf-info-table td:first-child{font-weight:600;width:35%;color:#555;padding-left:0;}'
      + '#pdf-export-content .pdf-summary-box{background:#FFFBF5;border-radius:6px;padding:16px 18px 16px 20px;font-size:13px;}'
      + '#pdf-export-content .pdf-summary-box div{margin-bottom:6px;}'
      + '#pdf-export-content .pdf-items-table{width:100%;border-collapse:collapse;font-size:12px;}'
      + '#pdf-export-content .pdf-items-table th,#pdf-export-content .pdf-items-table td{padding:8px 10px;border-bottom:1px solid #eee;}'
      + '#pdf-export-content .pdf-items-table th:first-child,#pdf-export-content .pdf-items-table td:first-child{padding-left:14px;text-align:left;}'
      + '#pdf-export-content .pdf-items-table th{background:#8B1538;color:#fff;font-weight:600;text-transform:uppercase;font-size:11px;}'
      + '#pdf-export-content .pdf-items-table th:not(:first-child),#pdf-export-content .pdf-items-table td:not(:first-child){text-align:center;width:80px;}'
      + '#pdf-export-content .pdf-items-table .pdf-col-image{width:52px;text-align:center;padding-left:10px;}'
      + '#pdf-export-content .pdf-items-table .pdf-col-name{text-align:left;width:auto;}'
      + '#pdf-export-content .pdf-items-table .pdf-col-num{text-align:center;width:78px;}'
      + '#pdf-export-content .pdf-item-image{width:42px;height:42px;object-fit:cover;border-radius:4px;display:block;margin:0 auto;background:#f7f7f7;}'
      + '#pdf-export-content .pdf-total-box{background:#8B1538;color:#fff;border-radius:8px;padding:18px 20px;text-align:center;margin-top:10px;}'
      + '#pdf-export-content .pdf-total-label{font-size:13px;font-weight:600;text-transform:uppercase;margin-bottom:5px;}'
      + '#pdf-export-content .pdf-total-value{font-size:32px;font-weight:700;line-height:1;margin-bottom:5px;}'
      + '#pdf-export-content .pdf-total-sub{font-size:11px;text-transform:uppercase;}'
      + '#pdf-export-content .pdf-footer{margin-top:25px;padding-top:12px;border-top:1px solid #eee;font-size:10px;color:#888;text-align:center;}';

    function loadScriptOnce(src, globalCheck) {
      return new Promise(function(resolve, reject) {
        if (globalCheck && globalCheck()) {
          resolve();
          return;
        }
        if (document.querySelector('script[data-q-pdf-src="' + src + '"]')) {
          const wait = function() {
            if (globalCheck && globalCheck()) resolve();
            else setTimeout(wait, 50);
          };
          wait();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.setAttribute('data-q-pdf-src', src);
        script.onload = function() { resolve(); };
        script.onerror = function() { reject(new Error('Script PDF: ' + src)); };
        document.head.appendChild(script);
      });
    }

    function loadPdfLibraries() {
      return Promise.all([
        loadScriptOnce(
          'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js',
          function() { return typeof window.html2canvas === 'function'; }
        ),
        loadScriptOnce(
          'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
          function() { return !!(window.jspdf && window.jspdf.jsPDF); }
        )
      ]);
    }

    function getJsPdfConstructor() {
      if (window.jspdf && window.jspdf.jsPDF) {
        return window.jspdf.jsPDF;
      }
      if (window.jsPDF) {
        return window.jsPDF;
      }
      return null;
    }

    function escapeHtmlText(value) {
      return escapeHtmlAttr(value);
    }

    function renderPdfImageCell(imageUrl, altText) {
      const src = String(imageUrl || '').trim();
      if (!src) {
        return '<td class="pdf-col-image"></td>';
      }
      return '<td class="pdf-col-image"><img class="pdf-item-image" src="' + escapeHtmlAttr(src) + '" alt="' + escapeHtmlAttr(altText || '') + '" crossorigin="anonymous"/></td>';
    }

    function waitForPdfImages(container, timeoutMs) {
      const limit = timeoutMs || 5000;
      const imgs = container ? container.querySelectorAll('img') : [];
      return Promise.all(Array.from(imgs).map(function(img) {
        if (img.complete && img.naturalWidth > 0) {
          return Promise.resolve();
        }
        return new Promise(function(resolve) {
          const done = function() { resolve(); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
          setTimeout(done, limit);
        });
      }));
    }

    function mountPdfContainerForCapture(container) {
      const savedParent = container.parentNode;
      const savedNext = container.nextSibling;
      document.body.appendChild(container);
      container.classList.add('pdf-export-capturing');
      container.setAttribute('aria-hidden', 'false');
      container.style.display = 'block';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      container.style.position = 'fixed';
      container.style.left = '0';
      container.style.top = '0';
      container.style.width = '794px';
      container.style.zIndex = '2147483646';
      return function restorePdfContainer() {
        container.classList.remove('pdf-export-capturing');
        container.setAttribute('aria-hidden', 'true');
        container.removeAttribute('style');
        if (savedParent) {
          savedParent.insertBefore(container, savedNext);
        }
      };
    }

    async function generateQuotePdfBlob(rootEl) {
      const html2canvasFn = window.html2canvas;
      const JsPDF = getJsPdfConstructor();
      if (!html2canvasFn || !JsPDF) {
        throw new Error('Bibliothèques PDF non chargées');
      }

      const target = rootEl;
      const captureWidth = Math.max(target.scrollWidth, target.offsetWidth, 794);
      const captureHeight = Math.max(target.scrollHeight, target.offsetHeight, 1);

      const canvas = await html2canvasFn(target, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: captureWidth,
        height: captureHeight,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
        scrollX: 0,
        scrollY: 0,
        onclone: function(clonedDoc) {
          const clonedRoot = clonedDoc.getElementById('pdf-export-content');
          if (clonedRoot) {
            clonedRoot.style.visibility = 'visible';
            clonedRoot.style.opacity = '1';
            clonedRoot.style.display = 'block';
            clonedRoot.style.position = 'static';
            clonedRoot.style.left = 'auto';
            clonedRoot.style.top = 'auto';
            clonedRoot.style.width = '794px';
            clonedRoot.style.padding = '36px 32px 36px 44px';
            clonedRoot.style.boxSizing = 'border-box';
            clonedRoot.style.background = '#ffffff';
            clonedRoot.style.color = '#000000';
          }
          const clonedPage = clonedDoc.querySelector('.pdf-page');
          if (clonedPage) {
            clonedPage.style.display = 'block';
            clonedPage.style.background = '#ffffff';
            clonedPage.style.padding = '4px 2px';
          }
        }
      });

      if (!canvas.width || !canvas.height) {
        throw new Error('Capture PDF vide (canvas 0×0)');
      }

      const pdf = new JsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const marginMm = 12;
      const printableWidth = pageWidth - marginMm * 2;
      const printableHeight = pageHeight - marginMm * 2;
      const imgWidth = printableWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL('image/jpeg', 0.92);
      let heightLeft = imgHeight;
      let position = marginMm;

      pdf.addImage(imgData, 'JPEG', marginMm, position, imgWidth, imgHeight);
      heightLeft -= printableHeight;

      while (heightLeft > 0) {
        position = marginMm - (imgHeight - heightLeft);
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginMm, position, imgWidth, imgHeight);
        heightLeft -= printableHeight;
      }

      return pdf.output('blob');
    }

    async function generateQuotePdfFile(rootEl, filename) {
      const blob = await generateQuotePdfBlob(rootEl);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
      return blob;
    }

    function getDevisNotificationConfig() {
      const cfg = window.questionnaireConfig || {};
      return cfg.devisNotification || {};
    }

    function isDevisNotificationEnabled() {
      const notif = getDevisNotificationConfig();
      return notif.enabled === true && String(notif.web3formsAccessKey || '').trim().length > 0;
    }

    function getDevisNotificationFingerprint(data) {
      const budgetEl = document.getElementById('summary-total-budget');
      const budget = budgetEl ? budgetEl.textContent.trim() : '';
      return [
        data.email || '',
        data.weddingDate || '',
        data.firstName || '',
        data.lastName || '',
        budget
      ].join('|').toLowerCase();
    }

    function wasDevisNotificationSent(fingerprint) {
      try {
        return sessionStorage.getItem(DEVIS_NOTIF_SENT_KEY) === fingerprint;
      } catch (e) {
        return false;
      }
    }

    function markDevisNotificationSent(fingerprint) {
      try {
        sessionStorage.setItem(DEVIS_NOTIF_SENT_KEY, fingerprint);
      } catch (e) {
        // ignore
      }
    }

    function formatNotificationItemLine(item) {
      const title = item.title || '—';
      const qty = item.quantity != null ? item.quantity : '';
      const flowers = item.flowers != null ? (' — ' + item.flowers + ' fleurs') : '';
      const price = item.unitPrice > 0
        ? (' — ' + formatPrice(toTtcPrice((item.unitPrice || 0) * (item.quantity || 1))))
        : '';
      const qtyPart = qty !== '' ? (' (×' + qty + ')') : '';
      return '- ' + title + qtyPart + flowers + price;
    }

    function getSelectedUniversTitle() {
      const el = document.querySelector('.univers-item.selected');
      if (!el) return '';
      const fromAttr = el.getAttribute('data-univers-title');
      if (fromAttr) return fromAttr.trim();
      const label = el.querySelector('.univers-item-title, .univers-item-label');
      return label ? label.textContent.trim() : '';
    }

    function buildDevisNotificationMessage(data) {
      const lines = [];
      const totalBudgetEl = document.getElementById('summary-total-budget');
      const totalFlowersEl = document.getElementById('summary-total-flowers');
      const durationEl = document.getElementById('summary-creation-duration');
      const univers = getSelectedUniversTitle();

      lines.push('Nouveau devis questionnaire FlorEasy');
      lines.push('Page : ' + (window.location.href || ''));
      lines.push('');
      lines.push('=== CLIENT ===');
      lines.push('Nom : ' + ((data.firstName || '') + ' ' + (data.lastName || '')).trim());
      lines.push('E-mail : ' + (data.email || '—'));
      lines.push('Date du mariage : ' + (data.weddingDate || '—'));
      lines.push('Code postal : ' + (data.postalCode || '—'));
      lines.push('Participants atelier : ' + (data.participants || '—'));
      lines.push('');

      lines.push('=== SYNTHÈSE ===');
      if (univers) lines.push('Univers floral : ' + univers);
      lines.push('Quantité totale de fleurs : ' + ((totalFlowersEl && totalFlowersEl.textContent) || '0'));
      lines.push('Pack DIY recommandé : ' + ((data.pack && data.pack.name) ? data.pack.name : '—'));
      if (data.pack && data.pack.size) lines.push('Taille pack : ' + data.pack.size);
      lines.push('Durée de création : ' + ((durationEl && durationEl.textContent) || '—'));
      lines.push('Budget total : ' + ((totalBudgetEl && totalBudgetEl.textContent) || '—'));
      lines.push('');

      if (data.freshItems && data.freshItems.length) {
        lines.push('=== FLEURS FRAÎCHES ===');
        data.freshItems.forEach(function(item) {
          lines.push(formatNotificationItemLine(item));
        });
        lines.push('');
      }

      if (data.supplements && data.supplements.length) {
        lines.push('=== SUPPLÉMENTS ===');
        data.supplements.forEach(function(item) {
          lines.push(formatNotificationItemLine(item));
        });
        lines.push('');
      }

      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice) {
        lines.push('Table d\'honneur : ' + tableHonneurChoice);
      }
      if (typeof archeChoice !== 'undefined' && archeChoice) {
        lines.push('Arche : ' + archeChoice);
      }
      if (typeof chairChoice !== 'undefined' && chairChoice) {
        lines.push('Bouquets de chaise : ' + chairChoice + (chairQuantity ? (' (×' + chairQuantity + ')') : ''));
      }
      if (typeof demoisellesChoice !== 'undefined' && demoisellesChoice) {
        lines.push('Demoiselles d\'honneur : ' + demoisellesChoice + (demoisellesQuantity ? (' (×' + demoisellesQuantity + ')') : ''));
      }

      lines.push('');
      lines.push('PDF du devis en pièce jointe.');
      return lines.join('\n');
    }

    function buildDevisPdfFilename(data) {
      const cfg = window.questionnaireConfig || {};
      const filenameParts = [cfg.pdfFilenamePrefix || 'Devis-FlorEasy'];
      if (data.firstName) filenameParts.push(String(data.firstName).replace(/\s+/g, '-'));
      if (data.weddingDate) filenameParts.push(String(data.weddingDate).replace(/\s+/g, '-'));
      return filenameParts.join('-') + '.pdf';
    }

    async function sendDevisNotificationToShop(options) {
      const notif = getDevisNotificationConfig();
      if (!isDevisNotificationEnabled()) return false;

      const data = (options && options.data) || getSummaryData();
      const fingerprint = getDevisNotificationFingerprint(data);
      if (wasDevisNotificationSent(fingerprint)) return false;

      const formData = new FormData();
      formData.append('access_key', String(notif.web3formsAccessKey).trim());
      formData.append(
        'subject',
        (notif.subjectPrefix || 'Nouveau devis FlorEasy') +
          ' — ' +
          (((data.firstName || '') + ' ' + (data.lastName || '')).trim() || 'Client')
      );
      formData.append(
        'from_name',
        (((data.firstName || '') + ' ' + (data.lastName || '')).trim() || 'Client FlorEasy')
      );
      formData.append('email', data.email || 'noreply@flor-easy.com');
      formData.append('message', buildDevisNotificationMessage(data));

      if (options && options.pdfBlob && options.pdfFilename) {
        formData.append('attachment', options.pdfBlob, options.pdfFilename);
      }

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      const result = await response.json();
      if (!result || !result.success) {
        throw new Error((result && result.message) || 'Envoi Web3Forms échoué');
      }

      markDevisNotificationSent(fingerprint);
      return true;
    }

    let devisNotificationInFlight = false;

    async function notifyShopOnDevisSummary() {
      if (!isDevisNotificationEnabled() || devisNotificationInFlight) return;

      invalidateSummaryCache();
      if (typeof populateSummary === 'function') populateSummary();

      const data = getSummaryData();
      const fingerprint = getDevisNotificationFingerprint(data);
      if (wasDevisNotificationSent(fingerprint)) return;

      devisNotificationInFlight = true;
      let restorePdfContainer = null;

      try {
        const filename = buildDevisPdfFilename(data);
        let pdfBlob = null;

        try {
          await loadPdfLibraries();
          const content = buildPdfContent();
          if (content && content.textContent && content.textContent.trim()) {
            restorePdfContainer = mountPdfContainerForCapture(content);
            await waitForPdfImages(content, 5000);
            await new Promise(function(resolve) {
              setTimeout(function() {
                requestAnimationFrame(function() {
                  requestAnimationFrame(resolve);
                });
              }, 150);
            });
            pdfBlob = await generateQuotePdfBlob(content);
          }
        } catch (pdfErr) {
          console.warn('[QV2] Génération PDF pour notification:', pdfErr);
        } finally {
          if (restorePdfContainer) restorePdfContainer();
        }

        await sendDevisNotificationToShop({
          data: data,
          pdfBlob: pdfBlob,
          pdfFilename: filename
        });
      } catch (err) {
        console.warn('[QV2] Notification devis non envoyée:', err);
        try {
          await sendDevisNotificationToShop({ data: data });
        } catch (fallbackErr) {
          console.warn('[QV2] Notification devis (sans PDF):', fallbackErr);
        }
      } finally {
        devisNotificationInFlight = false;
      }
    }

    function buildPdfContent() {
      const container = document.getElementById('pdf-export-content');
      if (!container) return null;
      container.innerHTML = '';

      const cfg = window.questionnaireConfig || {};
      const data = getSummaryData();
      const firstName   = data.firstName;
      const lastName    = data.lastName;
      const email       = data.email;
      const weddingDate = data.weddingDate;
      const postalCode  = data.postalCode;

      const totalFlowersEl = document.getElementById('summary-total-flowers');
      const durationEl = document.getElementById('summary-creation-duration');
      const partCountEl = document.getElementById('summary-participants-count');
      const totalBudgetEl = document.getElementById('summary-total-budget');

      const freshItems = data.freshItems;
      const supplements = data.supplements;
      const pack = data.pack;

      let html = '';
      html += '<div class="pdf-page">';

      // En-tête
      html += '<div class="pdf-header">';
      if (cfg.pdfLogo) {
        html += '<img class="pdf-logo" src="' + escapeHtmlAttr(cfg.pdfLogo) + '" alt="Logo" crossorigin="anonymous"/>';
      }
      html += '<div class="pdf-title">DEVIS FLORAL — Mariage</div>';
      html += '</div>';

      // Infos client
      html += '<div class="pdf-section">';
      html += '<h2>Informations client</h2>';
      html += '<table class="pdf-info-table">';
      if (firstName || lastName) {
        html += '<tr><td>Nom :</td><td>' + escapeHtmlText((firstName + ' ' + lastName).trim()) + '</td></tr>';
      }
      if (email) html += '<tr><td>Email :</td><td>' + escapeHtmlText(email) + '</td></tr>';
      if (weddingDate) html += '<tr><td>Date du mariage :</td><td>' + escapeHtmlText(weddingDate) + '</td></tr>';
      if (postalCode) html += '<tr><td>Code postal :</td><td>' + escapeHtmlText(postalCode) + '</td></tr>';
      html += '</table>';
      html += '</div>';

      // Résumé clé
      html += '<div class="pdf-section pdf-summary-box">';
      html += '<div><strong>Quantité totale de fleurs :</strong> ' + ((totalFlowersEl && totalFlowersEl.textContent) || '0') + '</div>';
      html += '<div><strong>Pack recommandé :</strong> ' + (pack && pack.name ? pack.name : '-') + '</div>';
      html += '<div><strong>Durée de création :</strong> ' + ((durationEl && durationEl.textContent) || '—') + ' pour ' + ((partCountEl && partCountEl.textContent) || '0') + ' personnes</div>';
      html += '</div>';

      // Pour rappel (fleurs fraîches)
      if (freshItems.length > 0) {
        html += '<div class="pdf-section">';
        html += '<h2>Éléments en fleurs fraîches</h2>';
        html += '<table class="pdf-items-table"><thead><tr><th class="pdf-col-image"></th><th class="pdf-col-name">Élément</th><th class="pdf-col-num">Fleurs</th></tr></thead><tbody>';
        freshItems.forEach(function(it) {
          html += '<tr>'
            + renderPdfImageCell(it.image, it.title)
            + '<td class="pdf-col-name">' + escapeHtmlText(it.title) + '</td>'
            + '<td class="pdf-col-num">+ ' + it.flowers + ' fleurs</td>'
            + '</tr>';
        });
        html += '</tbody></table>';
        html += '</div>';
      }

      // Kit de fleurs fraîche
      html += '<div class="pdf-section">';
      html += '<h2>Kit de fleurs fraîche</h2>';
      html += '<table class="pdf-items-table"><thead><tr><th class="pdf-col-image"></th><th class="pdf-col-name">Désignation</th><th class="pdf-col-num">Qt</th><th class="pdf-col-num">Prix unit</th><th class="pdf-col-num">Prix total</th></tr></thead><tbody>';
      if (pack && pack.name && pack.name !== '-') {
        const unitStr = pack.unitPrice > 0 ? formatPrice(toTtcPrice(pack.unitPrice)) : '—';
        const totStr  = pack.unitPrice > 0 ? formatPrice(toTtcPrice(pack.unitPrice * pack.quantity)) : '—';
        html += '<tr>'
          + renderPdfImageCell(pack.image, pack.name)
          + '<td class="pdf-col-name">' + escapeHtmlText(pack.name) + '</td>'
          + '<td class="pdf-col-num">' + pack.quantity + '</td>'
          + '<td class="pdf-col-num">' + unitStr + '</td>'
          + '<td class="pdf-col-num">' + totStr + '</td>'
          + '</tr>';
      } else {
        html += '<tr><td colspan="5">—</td></tr>';
      }
      html += '</tbody></table>';
      html += '</div>';

      // Suppléments
      if (supplements.length > 0) {
        html += '<div class="pdf-section">';
        html += '<h2>Suppléments</h2>';
        html += '<table class="pdf-items-table"><thead><tr><th class="pdf-col-image"></th><th class="pdf-col-name">Désignation</th><th class="pdf-col-num">Qt</th><th class="pdf-col-num">Prix unit</th><th class="pdf-col-num">Prix total</th></tr></thead><tbody>';
        supplements.forEach(function(it) {
          const total = (it.unitPrice || 0) * (it.quantity || 0);
          const unitTtc = toTtcPrice(it.unitPrice || 0);
          const totalTtc = toTtcPrice(total);
          html += '<tr>'
            + renderPdfImageCell(it.image, it.title)
            + '<td class="pdf-col-name">' + escapeHtmlText(it.title) + '</td>'
            + '<td class="pdf-col-num">' + (it.quantity || 0) + '</td>'
            + '<td class="pdf-col-num">' + (it.unitPrice > 0 ? formatPrice(unitTtc) : '—') + '</td>'
            + '<td class="pdf-col-num">' + (it.unitPrice > 0 ? formatPrice(totalTtc) : '—') + '</td>'
            + '</tr>';
        });
        html += '</tbody></table>';
        html += '</div>';
      }

      // Budget total
      html += '<div class="pdf-section pdf-total-box">';
      html += '<div class="pdf-total-label">BUDGET TOTAL DU MARIAGE (TTC)</div>';
      html += '<div class="pdf-total-value">' + ((totalBudgetEl && totalBudgetEl.textContent) || '0 € TTC') + '</div>';
      html += '<div class="pdf-total-sub">Kit DIY + Suppléments (TTC)</div>';
      html += '</div>';

      // Footer
      if (cfg.pdfFooterText) {
        html += '<div class="pdf-footer">' + String(cfg.pdfFooterText).replace(/\n/g, '<br/>') + '</div>';
      }

      html += '</div>';

      container.innerHTML = '<style>' + PDF_INLINE_STYLES + '</style>' + html;
      return container;
    }

    async function handleDownloadQuote() {
      const btn = document.getElementById('download-quote-btn');
      if (!btn) return;
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Génération du PDF...';
      let restorePdfContainer = null;
      try {
        if (typeof populateSummary === 'function') {
          populateSummary();
        }
        await loadPdfLibraries();
        const content = buildPdfContent();
        if (!content) throw new Error('Contenu PDF introuvable');
        if (!content.textContent || !content.textContent.trim()) {
          throw new Error('Le contenu du devis est vide');
        }

        restorePdfContainer = mountPdfContainerForCapture(content);
        await waitForPdfImages(content, 5000);
        await new Promise(function(resolve) {
          setTimeout(function() {
            requestAnimationFrame(function() {
              requestAnimationFrame(resolve);
            });
          }, 150);
        });

        const data = getSummaryData();
        const filename = buildDevisPdfFilename(data);

        await generateQuotePdfFile(content, filename);
      } catch (err) {
        console.error('Erreur génération PDF:', err);
        alert('Une erreur est survenue lors de la génération du PDF. Veuillez réessayer.');
      } finally {
        if (restorePdfContainer) {
          restorePdfContainer();
        }
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }

    safeAddEventListener(getElement('download-quote-btn'), 'click', handleDownloadQuote);

    /* ----------- Validation du form étape 17 (informations client) ----------- */
    function getQuestionnaireCustomerConfig() {
      return (window.questionnaireConfig && window.questionnaireConfig.customer) || {};
    }

    function isQuestionnaireCustomerLoggedIn() {
      return getQuestionnaireCustomerConfig().loggedIn === true;
    }

    function hydrateLoggedInCustomerFields() {
      const customer = getQuestionnaireCustomerConfig();
      const fieldMap = {
        'RegisterForm-FirstName': customer.firstName,
        'RegisterForm-LastName': customer.lastName,
        'RegisterForm-email': customer.email
      };

      Object.keys(fieldMap).forEach(function(id) {
        const input = document.getElementById(id);
        const value = fieldMap[id];
        if (input && value) {
          if (!input.value) {
            input.value = value;
          }
          input.readOnly = true;
          input.classList.add('readonly-field');
        }
      });
    }

    function isValidAccountEmail(value) {
      const email = (value || '').trim();
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function getAccountFieldWrapper(input) {
      return input ? input.closest('.form-field') : null;
    }

    function setAccountFieldError(input, message) {
      const wrapper = getAccountFieldWrapper(input);
      if (!wrapper) {
        return;
      }
      let hint = wrapper.querySelector('.form-field-error');
      if (message) {
        wrapper.classList.add('form-field-invalid');
        if (!hint) {
          hint = document.createElement('p');
          hint.className = 'form-field-error';
          hint.setAttribute('role', 'alert');
          wrapper.appendChild(hint);
        }
        hint.textContent = message;
        hint.hidden = false;
      } else {
        wrapper.classList.remove('form-field-invalid');
        if (hint) {
          hint.hidden = true;
          hint.textContent = '';
        }
      }
    }

    function validateCreateAccountForm() {
      const submitBtn = document.getElementById('create-account-btn');
      const summaryEl = document.getElementById('account-form-validation-summary');
      if (!submitBtn) {
        return false;
      }

      const lastName = document.getElementById('RegisterForm-LastName');
      const firstName = document.getElementById('RegisterForm-FirstName');
      const email = document.getElementById('RegisterForm-email');
      const postalCode = document.getElementById('RegisterForm-PostalCode');

      const issues = [];
      let isValid = true;

      if (!lastName || !lastName.value.trim()) {
        isValid = false;
        setAccountFieldError(lastName, 'Indiquez votre nom.');
        issues.push('nom');
      } else {
        setAccountFieldError(lastName, '');
      }

      if (!firstName || !firstName.value.trim()) {
        isValid = false;
        setAccountFieldError(firstName, 'Indiquez votre prénom.');
        issues.push('prénom');
      } else {
        setAccountFieldError(firstName, '');
      }

      if (!email || !email.value.trim()) {
        isValid = false;
        setAccountFieldError(email, 'Indiquez votre adresse e-mail.');
        issues.push('e-mail');
      } else if (!isValidAccountEmail(email.value)) {
        isValid = false;
        setAccountFieldError(email, 'Adresse e-mail invalide (ex. prenom@exemple.fr).');
        issues.push('e-mail valide');
      } else {
        setAccountFieldError(email, '');
      }

      const weddingDateRecap = document.getElementById('account-wedding-date-recap');
      syncAccountWeddingDateField(true);
      const hiddenWeddingDate = document.getElementById('RegisterForm-WeddingDate');
      const displayWeddingDate = document.getElementById('account-wedding-date-display');
      let weddingDateValue = getWeddingDateValue();
      if (!weddingDateValue && hiddenWeddingDate && hiddenWeddingDate.value) {
        weddingDateValue = hiddenWeddingDate.value.trim();
      }
      if (!weddingDateValue && displayWeddingDate) {
        weddingDateValue = (displayWeddingDate.getAttribute('data-iso-date') || '').trim();
      }

      if (weddingDateRecap || hiddenWeddingDate) {
        if (!weddingDateValue) {
          isValid = false;
          if (weddingDateRecap) {
            weddingDateRecap.classList.add('form-field-invalid');
            let hint = weddingDateRecap.querySelector('.form-field-error');
            if (!hint) {
              hint = document.createElement('p');
              hint.className = 'form-field-error';
              hint.setAttribute('role', 'alert');
              weddingDateRecap.appendChild(hint);
            }
            hint.textContent = 'Date manquante : retournez à l’étape 1 pour choisir la date de votre mariage.';
            hint.hidden = false;
          }
          issues.push('date de mariage (étape 1)');
        } else {
          if (weddingDateRecap) {
            weddingDateRecap.classList.remove('form-field-invalid');
            const hint = weddingDateRecap.querySelector('.form-field-error');
            if (hint) {
              hint.hidden = true;
              hint.textContent = '';
            }
          }
        }
      }

      if (postalCode) {
        const postalValue = postalCode.value.trim().replace(/\s/g, '');
        if (postalValue !== postalCode.value.trim()) {
          postalCode.value = postalValue;
        }
        if (!postalValue) {
          isValid = false;
          setAccountFieldError(postalCode, 'Indiquez votre code postal (5 chiffres).');
          issues.push('code postal');
        } else if (!/^[0-9]{5}$/.test(postalValue)) {
          isValid = false;
          setAccountFieldError(
            postalCode,
            'Code postal invalide : saisissez 5 chiffres (ex. 75001).'
          );
          issues.push('code postal à 5 chiffres');
        } else {
          setAccountFieldError(postalCode, '');
        }
      }

      if (summaryEl) {
        if (!isValid && issues.length) {
          summaryEl.hidden = false;
          summaryEl.textContent =
            'Pour activer le bouton, corrigez : ' + issues.join(', ') + '.';
        } else {
          summaryEl.hidden = true;
          summaryEl.textContent = '';
        }
      }

      setValidationButtonState(submitBtn, !isValid);
      return isValid;
    }

    window.__qv2ValidateCreateAccountForm = validateCreateAccountForm;

    function isCrossOriginUrl(url) {
      if (!url || url.indexOf('javascript:') === 0) {
        return false;
      }
      try {
        return new URL(url, window.location.href).origin !== window.location.origin;
      } catch (err) {
        return false;
      }
    }

    function getAccountRegisterUrl(form) {
      if (!form) {
        return '';
      }
      const saved = form.getAttribute('data-register-action');
      if (saved && saved.indexOf('javascript:') !== 0) {
        return saved;
      }
      const action = form.getAttribute('action') || '';
      if (action && action.indexOf('javascript:') !== 0) {
        return action;
      }
      return '/account';
    }

    function submitAccountInBackground() {
      const form = document.getElementById('questionnaire-create-account-form');
      const actionUrl = getAccountRegisterUrl(form);
      if (!form || !actionUrl) {
        return;
      }

      if (isCrossOriginUrl(actionUrl)) {
        let iframe = document.getElementById('questionnaire-account-submit-frame');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.id = 'questionnaire-account-submit-frame';
          iframe.name = 'questionnaire-account-submit-frame';
          iframe.setAttribute('title', 'Création de compte');
          iframe.hidden = true;
          iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(iframe);
        }
        const prevAction = form.getAttribute('action');
        const prevTarget = form.getAttribute('target');
        form.setAttribute('action', actionUrl);
        form.setAttribute('target', iframe.name);
        try {
          HTMLFormElement.prototype.submit.call(form);
        } catch (err) {
          console.warn('[Questionnaire] Création de compte en arrière-plan:', err);
        } finally {
          setTimeout(function() {
            form.setAttribute('action', prevAction || 'javascript:void(0)');
            if (prevTarget) {
              form.setAttribute('target', prevTarget);
            } else {
              form.removeAttribute('target');
            }
          }, 0);
        }
        return;
      }

      fetch(actionUrl, {
        method: (form.method || 'POST').toUpperCase(),
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'manual'
      }).catch(function(err) {
        console.warn('[Questionnaire] Création de compte en arrière-plan:', err);
      });
    }

    function goToSummaryFromAccountStep() {
      try {
        saveSummarySnapshot();
      } catch (err) {
        console.error('saveSummarySnapshot:', err);
      }
      qv2ShowStep(18);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    window.__questionnaireGoToSummary = function() {
      if (!validateCreateAccountForm()) {
        return;
      }
      goToSummaryFromAccountStep();
    };

    /* ----------- Boutons d'action ----------- */
    safeAddEventListener(getElement('restart-questionnaire-btn'), 'click', function() {
      clearSummarySnapshot();
      qv2ShowStep(1);
      if (!window.QV2) { window.location.reload(); }
    });

    function parseVariantId(value) {
      const v = String(value || '').replace(/\s/g, '');
      return /^\d+$/.test(v) ? parseInt(v, 10) : 0;
    }

    function normalizeCartVariantRef(value) {
      if (value && typeof value === 'object') {
        if (value.id || value.handle) return value;
        return '';
      }
      const ref = String(value || '').trim();
      if (!ref || ref === 'ID_VARIANTE_A_REMPLIR') return '';
      return ref;
    }

    const cartVariantHandleCache = new Map();

    function normalizeProductHandle(value) {
      return String(value || '')
        .trim()
        .replace(/^handle:/i, '')
        .replace(/^\/products\//i, '')
        .replace(/^https?:\/\/[^/]+\/products\//i, '')
        .replace(/\.js$/i, '')
        .split(/[?#]/)[0]
        .trim();
    }

    async function resolveCartVariantRef(ref) {
      if (ref && typeof ref === 'object') {
        if (ref.id) return parseVariantId(ref.id);
        const handle = normalizeProductHandle(ref.handle || '');
        if (!handle) return 0;
        const cacheKey = handle + '|' + String(ref.option1 || '') + '|' + String(ref.option2 || '') + '|' + String(ref.option3 || '');
        if (cartVariantHandleCache.has(cacheKey)) {
          return cartVariantHandleCache.get(cacheKey);
        }

        try {
          const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
          if (!response.ok) throw new Error('Produit introuvable: ' + handle);
          const product = await response.json();
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const variant = variants.find(function(v) {
            if (!v) return false;
            if (ref.option1 && String(v.option1 || '') !== String(ref.option1)) return false;
            if (ref.option2 && String(v.option2 || '') !== String(ref.option2)) return false;
            if (ref.option3 && String(v.option3 || '') !== String(ref.option3)) return false;
            return true;
          }) || variants.find(function(v) { return v && v.available; }) || variants[0];
          const id = variant && parseVariantId(variant.id);
          cartVariantHandleCache.set(cacheKey, id || 0);
          return id || 0;
        } catch (err) {
          console.warn('[Questionnaire] Variante introuvable pour le mapping:', ref, err);
          cartVariantHandleCache.set(cacheKey, 0);
          return 0;
        }
      }

      const numericId = parseVariantId(ref);
      if (numericId) return numericId;

      const handle = normalizeProductHandle(ref);
      if (!handle) return 0;
      if (cartVariantHandleCache.has(handle)) {
        return cartVariantHandleCache.get(handle);
      }

      const productUrl = '/products/' + encodeURIComponent(handle) + '.js';
      try {
        const response = await fetch(productUrl, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Produit introuvable: ' + handle);
        const product = await response.json();
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants.find(function(v) { return v && v.available; }) || variants[0];
        const id = variant && parseVariantId(variant.id);
        cartVariantHandleCache.set(handle, id || 0);
        return id || 0;
      } catch (err) {
        console.warn('[Questionnaire] Variante introuvable pour le handle:', handle, err);
        cartVariantHandleCache.set(handle, 0);
        return 0;
      }
    }

    async function resolveQuestionnaireCartItems(items) {
      const resolvedMap = new Map();
      for (const item of items) {
        const id = await resolveCartVariantRef(item.id);
        if (!id) continue;
        const existing = resolvedMap.get(id);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          resolvedMap.set(id, {
            id: id,
            quantity: item.quantity,
            properties: item.properties
          });
        }
      }
      return Array.from(resolvedMap.values());
    }

    function normalizeCartLookupKey(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function lookupCartMap(map, label, blockId) {
      if (!map || typeof map !== 'object') return '';
      if (blockId && map[blockId] != null && map[blockId] !== '') {
        return map[blockId];
      }
      const key = normalizeCartLookupKey(label);
      if (!key) return '';
      const keys = Object.keys(map);
      for (let i = 0; i < keys.length; i++) {
        if (normalizeCartLookupKey(keys[i]) === key) return map[keys[i]];
      }
      return '';
    }

    function lookupUniversPackVariants(cv, universEl) {
      if (!universEl || !cv || !cv.univers) return null;
      const blockId = universEl.getAttribute('data-univers-id');
      const title = universEl.getAttribute('data-univers-title') || '';
      let entry = (blockId && cv.univers[blockId]) ? cv.univers[blockId] : null;
      if (!entry) {
        const matched = lookupCartMap(cv.univers, title, blockId);
        entry = (matched && typeof matched === 'object') ? matched : null;
      }
      return entry;
    }

    function getLineItemProperties() {
      const data = getSummaryData();
      const props = { Source: 'Questionnaire mariage' };
      if (data.weddingDate) props['Date du mariage'] = data.weddingDate;
      const name = ((data.firstName || '') + ' ' + (data.lastName || '')).trim();
      if (name) props.Client = name;
      return props;
    }

    function buildQuestionnaireCartItems() {
      syncQV2State();
      const cfg = window.questionnaireConfig || {};
      const cv = cfg.cartVariants || {};
      const lineProps = getLineItemProperties();
      const itemsMap = new Map();

      function addItem(variantId, quantity) {
        const id = normalizeCartVariantRef(variantId);
        const qty = Math.max(0, parseInt(quantity, 10) || 0);
        if (!id || qty <= 0) return;
        const key = (id && typeof id === 'object') ? JSON.stringify(id) : id;
        const existing = itemsMap.get(key);
        if (existing) {
          existing.quantity += qty;
        } else {
          itemsMap.set(key, { id: id, quantity: qty, properties: Object.assign({}, lineProps) });
        }
      }

      function variantFromColorSelect(selectEl, colorMap, fallback) {
        if (!selectEl || !selectEl.value) return fallback;
        return lookupCartMap(colorMap, selectEl.value, '') || fallback;
      }

      // Pack DIY (univers × taille S/M/L)
      const pack = getRecommendedPackInfo();
      const universEl = document.querySelector('.univers-item.selected');
      const sizes = lookupUniversPackVariants(cv, universEl);
      if (sizes) {
        const packKey = (pack && pack.size) ? String(pack.size).toLowerCase() : 's';
        const variantId = sizes[packKey] || sizes.s;
        addItem(variantId, 1);
      }

      // Matériels
      document.querySelectorAll('.material-item').forEach(function(card) {
        const materialId = card.getAttribute('data-material-id');
        const qInput = card.querySelector('.quantity-input[data-material-id]');
        const qty = parseInt(qInput && qInput.value, 10) || 0;
        if (qty <= 0) return;
        const titleEl = card.querySelector('.material-item-title');
        const title = titleEl ? titleEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.materials, title, materialId), qty);
      });

      // Contenants
      document.querySelectorAll('.container-item').forEach(function(el) {
        const containerId = el.getAttribute('data-container-id');
        const qtyInput = el.querySelector('#container-quantity-' + containerId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;
        const labelEl = el.querySelector('.container-item-label');
        const title = labelEl ? labelEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.containers, title, containerId), qty);
      });

      // Sacs cadeaux
      document.querySelectorAll('.gift-bag-item').forEach(function(el) {
        const bagId = el.getAttribute('data-gift-bag-id');
        const qtyInput = el.querySelector('#gift-bag-quantity-' + bagId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;
        const labelEl = el.querySelector('.gift-bag-item-label');
        const title = labelEl ? labelEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.giftBags, title, bagId), qty);
      });

      // Table d'honneur artificielle
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'artificial') {
        const select = document.getElementById('table-honneur-color');
        addItem(variantFromColorSelect(select, cv.tableHonneurColors, cv.step9Artificial), 1);
      }

      // Arche artificielle
      if (typeof archeChoice !== 'undefined' && archeChoice === 'artificial') {
        const select = document.getElementById('arche-color');
        addItem(variantFromColorSelect(select, cv.archeColors, cv.step10Artificial), 1);
      }

      // Bouquets de chaise artificiels
      if (typeof chairChoice !== 'undefined' && chairChoice === 'artificial') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        if (nbChairs > 0) {
          const select = document.getElementById('chair-color');
          addItem(variantFromColorSelect(select, cv.chairColors, cv.step11Artificial), nbChairs);
        }
      }

      // Accessoires stabilisés
      document.querySelectorAll('.step12-accessories-option.selected').forEach(function(el) {
        const accessoryId = el.getAttribute('data-accessory-id');
        const qtyInput = el.querySelector('#accessory-quantity-' + accessoryId)
          || el.querySelector('.quantity-input[data-accessory-id="' + accessoryId + '"]');
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;
        const titleEl = el.querySelector('.table-honneur-title');
        const accessoryTitle = titleEl ? titleEl.textContent.trim() : '';
        const colorSelect = el.querySelector('.accessories-color-select');
        const colorName = colorSelect ? colorSelect.value : '';
        const mapKey = accessoryTitle && colorName
          ? (accessoryTitle + '|' + colorName)
          : colorName;
        const vid = lookupCartMap(cv.accessoryColors, mapKey, accessoryId)
          || (colorSelect ? variantFromColorSelect(colorSelect, cv.accessoryColors, '') : '');
        addItem(vid, qty);
      });

      // Bottes supplémentaires (étape 16)
      if (window.QV2_STEPS_16 && typeof window.QV2_STEPS_16.getFlowerBundlesForSummary === 'function') {
        window.QV2_STEPS_16.getFlowerBundlesForSummary().forEach(function (b) {
          if (!b.quantity || b.quantity <= 0) return;
          addItem(lookupCartMap(cv.flowers, b.title, b.varietyId), b.quantity);
        });
      } else {
        document.querySelectorAll('.flowers-variety-item').forEach(function(card) {
          const varietyId = card.getAttribute('data-variety-id');
          const qtyEl = card.querySelector('.flower-variety-bundles-value');
          const qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
          if (qty <= 0) return;
          const nameEl = card.querySelector('.flower-variety-name');
          const name = nameEl ? nameEl.textContent.trim() : '';
          addItem(lookupCartMap(cv.flowers, name, varietyId), qty);
        });
      }

      return Array.from(itemsMap.values());
    }

    function updateCartButtonState() {
      const btn = document.getElementById('add-to-cart-btn');
      if (!btn) return;
      const items = buildQuestionnaireCartItems();
      const hasItems = items.length > 0;
      btn.disabled = !hasItems;
      btn.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
    }

    async function handleAddQuestionnaireToCart() {
      const btn = document.getElementById('add-to-cart-btn');
      if (!btn || btn.disabled) return;

      const itemsToResolve = buildQuestionnaireCartItems();
      if (!itemsToResolve.length) {
        alert('Aucun produit ne peut être ajouté au panier : complétez le champ « Panier — mapping variantes (JSON) » dans les réglages de la section Questionnaire (étape 18).');
        return;
      }

      const routesObj = (typeof window.routes !== 'undefined' && window.routes) ? window.routes : {};
      const cartUrl = routesObj.cart_add_url || '/cart/add.js';
      const cartBubble = document.querySelector('cart-dropdown-bubble');
      const originalText = btn.textContent;

      btn.classList.add('loading');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = 'Ajout au panier...';

      try {
        const items = await resolveQuestionnaireCartItems(itemsToResolve);
        if (!items.length) {
          alert('Aucun produit ne peut être ajouté au panier : les handles/variantes configurés sont introuvables dans Shopify.');
          return;
        }

        const bodyObj = { items: items };
        if (cartBubble && typeof cartBubble.getSectionsToRender === 'function') {
          try {
            bodyObj.sections = cartBubble.getSectionsToRender().map(function(s) { return s.id; });
            bodyObj.sections_url = window.location.pathname;
          } catch (e) { /* ignore */ }
        }

        const response = await fetch(cartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bodyObj)
        });
        const data = await response.json();

        if (data.status) {
          const msg = data.description || data.message || 'Impossible d\'ajouter au panier.';
          if (cartBubble && typeof cartBubble.renderError === 'function') {
            cartBubble.renderError(msg);
          } else {
            alert(msg);
          }
          return;
        }

        clearSummarySnapshot();

        if (cartBubble && typeof cartBubble.renderContents === 'function') {
          if (items.length === 1) data.quantityItem = items[0].quantity;
          cartBubble.renderContents(data);
        }

        if (window.cartAjax && typeof openCartModal === 'function') {
          openCartModal();
        } else {
          window.location.href = routesObj.cart_url || '/cart';
        }
      } catch (err) {
        console.error('Erreur ajout panier questionnaire:', err);
        alert('Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.');
      } finally {
        btn.classList.remove('loading');
        btn.textContent = originalText;
        updateCartButtonState();
      }
    }

    safeAddEventListener(getElement('add-to-cart-btn'), 'click', function(e) {
      e.preventDefault();
      handleAddQuestionnaireToCart();
    });
    safeAddEventListener(document, 'questionnaire:cartVariantsLoaded', updateCartButtonState);

  function initAccountFormValidation() {
    const accountForm = document.getElementById('questionnaire-create-account-form');
    if (!accountForm) return;

    if (typeof hydrateLoggedInCustomerFields === 'function') {
      hydrateLoggedInCustomerFields();
    }

    const registerAction = accountForm.getAttribute('data-register-action') ||
      accountForm.getAttribute('action');
    if (registerAction && registerAction.indexOf('javascript:') !== 0) {
      accountForm.setAttribute('data-register-action', registerAction);
    } else if (!accountForm.getAttribute('data-register-action')) {
      accountForm.setAttribute('data-register-action', '/account');
    }
    accountForm.setAttribute('action', 'javascript:void(0)');

    syncAccountWeddingDateField();

    if (!accountForm.dataset.qv2ValidationBound) {
      accountForm.dataset.qv2ValidationBound = '1';
      accountForm.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('input', requestAccountFormValidation);
        input.addEventListener('change', requestAccountFormValidation);
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (window.__questionnaireGoToSummary) window.__questionnaireGoToSummary();
          }
        });
      });
      document.addEventListener('qv2:weddingDateChanged', function () {
        syncAccountWeddingDateField();
      });
      document.addEventListener('qv2:stepShown', function (e) {
        if (e.detail && Number(e.detail.step) === 17) {
          syncAccountWeddingDateField();
          setTimeout(requestAccountFormValidation, 0);
          setTimeout(requestAccountFormValidation, 200);
        }
      });
    }

    requestAccountFormValidation();
  }

  function bindAccountStepNoRedirect() {
    const form = document.getElementById('questionnaire-create-account-form');
    const btn = document.getElementById('create-account-btn');
    if (!form || !btn || form.dataset.qv2AccountBound) return;
    form.dataset.qv2AccountBound = '1';
    form.setAttribute('action', 'javascript:void(0)');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.__questionnaireGoToSummary) window.__questionnaireGoToSummary();
      return false;
    }, true);
    btn.setAttribute('type', 'button');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      if (window.__questionnaireGoToSummary) {
        window.__questionnaireGoToSummary();
      } else {
        qv2ShowStep(18);
        window.scrollTo(0, 0);
      }
    }, true);
  }

  function initSteps1718() {
    if (!document.querySelector('[data-qv2-section="17-18"]') &&
        !document.getElementById('create-account-btn') &&
        !document.getElementById('summary-total-budget')) {
      return;
    }
    loadQuestionnaireConfig();
    bindAccountStepNoRedirect();
    initAccountFormValidation();
    if (!initialized) {
      initialized = true;
    }
  }

  function onStepShown(stepNumber) {
    if (stepNumber === 17) {
      if (window.QV2 && typeof window.QV2.forceFlushWeddingDateInput === 'function') {
        window.QV2.forceFlushWeddingDateInput();
      } else if (window.QV2 && typeof window.QV2.captureWeddingDateSnapshot === 'function') {
        window.QV2.captureWeddingDateSnapshot();
      }
      initSteps1718();
      loadQuestionnaireConfig();
      bindAccountStepNoRedirect();
      initAccountFormValidation();
      syncAccountWeddingDateField();
      setTimeout(requestAccountFormValidation, 0);
      setTimeout(requestAccountFormValidation, 200);
      if (typeof saveSummarySnapshot === 'function') saveSummarySnapshot();
    }
    if (stepNumber === 18) {
      initSteps1718();
      loadQuestionnaireConfig();
      if (typeof populateSummary === 'function') populateSummary();
      setTimeout(function () {
        if (typeof populateSummary === 'function') populateSummary();
      }, 150);
      setTimeout(function () {
        notifyShopOnDevisSummary();
      }, 800);
    }
  }

  window.QV2_STEPS_17_18 = {
    init: initSteps1718,
    onStepShown: onStepShown,
    syncWeddingDate: syncAccountWeddingDateField,
    populateSummary: function () {
      if (typeof populateSummary === 'function') populateSummary();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSteps1718);
  } else {
    initSteps1718();
  }
})();
